import React, { Component } from "react";
import cn from "classnames";
import Layout from "../Layout";
import "./CenterLayout.less";

const CLASS_NAME = "fct-center-layout";

class CenterLayout extends Component {
  render() {
    const { children, className, ...props } = this.props;
    return (
      <Layout
        className={cn(
          props.scrollable || props.scrollx || props.scrolly
            ? "clearfix"
            : CLASS_NAME,
          className
        )}
        {...props}
      >
        {props.scrollable || props.scrollx || props.scrolly ? (
          <div className={cn(CLASS_NAME, "layout-wrapper")}>{children}</div>
        ) : (
          children
        )}
      </Layout>
    );
  }
}
export default CenterLayout;



// WEBPACK FOOTER //
// ./layout/center/CenterLayout.js